import React from 'react';
import { HeroSection } from './components/HeroSection';
import { DiagnosisSection } from './components/DiagnosisSection';
import { SystemSection } from './components/SystemSection';
import { StatsSection } from './components/StatsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { ContactForm } from './components/ContactForm';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen w-full bg-carbon text-light font-sans selection:bg-gold selection:text-carbon overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <DiagnosisSection data-id="element-2" />
      <SystemSection data-id="element-3" />
      <StatsSection data-id="element-4" />
      <TestimonialsSection data-id="element-5" />
      <FAQSection data-id="element-6" />
      <ContactForm data-id="element-7" />
      <FinalCTA data-id="element-8" />
      <Footer data-id="element-9" />
    </main>;
}